'use client'

import { Button } from '@mui/material'

// Types
import type { TextButtonProps } from '@/types/components/atoms/buttons/text'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const PinkButtonAtom = (props: TextButtonProps) => {
	// Props
	const { lng, title, startIcon, endIcon, onClick } = props

	// Varaibles
	const { t } = useTranslation(lng)

	return (
		<Button
			variant="contained"
			disableElevation
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
			sx={{
				py: { xs: 1.5, md: 2 },
				px: { xs: 2.5, md: 5 },
				fontSize: { xs: 14, md: 18 },
				lineHeight: 1,
				fontWeight: 900,
				textTransform: 'inherit',
				color: 'common.white',
				bgcolor: 'primary.main',
				borderRadius: 2,
				'& .MuiButton-icon': {
					width: { xs: 40, md: 50 },
					height: { xs: 40, md: 50 },
					mx: 'inherit',
					p: { xs: 1, md: 1.625 },
					position: 'absolute',
					top: 0,
					color: '#292d32',
					bgcolor: 'common.white',
					borderRadius: 5,
					'&.MuiButton-startIcon': { left: { xs: -30, md: -40 } },
					'&.MuiButton-endIcon': { right: { xs: -30, md: -40 } },
					'& .MuiSvgIcon-root': { fontSize: 24 }
				}
			}}
		>
			{t(title)}
		</Button>
	)
}

export default PinkButtonAtom
